import { useCallback, useState } from "react";
import { useCreateSpeakingClassServiceAdminAxiosInstance } from "../../Auth/useCreateSpeakingClassServiceAdminAxiosInstance.ts";
import {
  WithdrawablePurchaseDTO,
  WithdrawalRequestDTO,
} from "./WithdrawalRequestDTO.ts";

export type WithdrawalRequestsByEmail = {
  userId: string;
  requests: WithdrawalRequestDTO[];
  withdrawablePurchases: WithdrawablePurchaseDTO[];
};

export function useWithdrawalRequestsByEmail() {
  const { createAxiosInstance } =
    useCreateSpeakingClassServiceAdminAxiosInstance();
  const [loading, setLoading] = useState(false);

  const getByEmail = useCallback(
    async (email: string): Promise<WithdrawalRequestsByEmail | null> => {
      setLoading(true);
      try {
        const { data } =
          await createAxiosInstance().get<WithdrawalRequestsByEmail>(
            `/withdrawal-requests/by-email/${encodeURIComponent(email)}`,
          );
        return data;
      } catch {
        return null;
      } finally {
        setLoading(false);
      }
    },
    [createAxiosInstance],
  );

  return { getByEmail, loading };
}
